<template>
  <div>
    <Item
        name="getUserId"
        :value="userId"
        @updateValue="getUserId"
    />
    <Item
        name="getDesignId"
        :value="designId"
        @updateValue="getDesignId"
    />
    <Item
        name="getDesignId"
        :value="designName"
        @updateValue="getDesignName"
    />
    <button @click="getComputeLayout">点击查看信息</button>
    <button @click="getMessage('elementType')">点击查看信息</button>
    <button @click="toTest">to test</button>
    <button @click="save">保存localStorage内容</button>
    <button @click="show">显示localStorage内容</button>
    <button @click="del">删除localStorage内容</button>
    <div>storage:{{xxx}}</div>
  </div>
</template>

<script>
import Item from "../components/Item.vue";

export default {
  name: "List",
  components: {Item},
  data() {
    return {

      userId: '',
      designId: '',
      designName:'',
      computeLayout: '',
      xxx:''
    }
  },
  mounted() {
    window.addEventListener("message", this.onmessage);
    // this.getUserId()
  },
  beforeDestroy() {
    window.removeEventListener("message", this.onmessage);
  },
  methods: {
    del(){
      window.localStorage.removeItem("userInfo")
    },
    save(){
      window.localStorage.setItem("userInfo",'用户信息')
    },
    show(){
      this.xxx = window.localStorage.getItem("userInfo")
    },
    getMessage(event){
      window.parent.postMessage({action: event}, "*");
    },
    toTest(){
      this.$router.push('/login')
    },
    onmessage(event) {
      console.log(event, 'event');
      if (event.data.action === "userId") {
        this.userId = event.data.value;
      } else if (event.data.action === "designId") {
        this.designId = event.data.value;
      } else if(event.data.action ==='computeLayout'){
        console.log(JSON.stringify(event.data.value))
      } else if(event.data.action ==='designName'){
        this.designName = event.data.value;
      }
    },
    getUserId() {
      window.parent.postMessage({action: "getUserId"}, "*");
    },
    getDesignId() {
      window.parent.postMessage({action: "getDesignId"}, "*");
    },
    getDesignName() {
      window.parent.postMessage({action: "getName"}, "*");
    },
    getComputeLayout() {
      window.parent.postMessage({action: "computeLayout"}, "*");
    }

  }
}
</script>

<style scoped>

</style>
